import { Link } from "react-router-dom";

export default function ArticleHeader({
    article,
}) {
    const category =
        article.categories?.[0];


    return (
        <header className="article-header">

            {category && (
                <Link
                    className="article-header__category"
                    to={`/articles?category=${category.id}`}
                >
                    {category.title}
                </Link>
            )}


            <h1 className="article-header__title">
                {article.title}
            </h1>


            {article.description && (
                <p className="article-header__description">
                    {article.description}
                </p>
            )}


            <div className="article-header__meta">

                {article.writer && (
                    <div className="article-meta-item">

                        {/* <span className="article-meta-item__icon">
                            ✍
                        </span>

                        <span>
                            {article.writer}
                        </span> */}

                    </div>
                )}


                {article.publishedAt && (
                    <div className="article-meta-item">

                        <span className="article-meta-item__icon">
                            📅
                        </span>

                        <span>
                            {formatPersianDate(
                                article.publishedAt
                            )}
                        </span>

                    </div>
                )}


                <div className="article-meta-item">

                    <span className="article-meta-item__icon">
                        👁
                    </span>

                    <span>
                        {formatVisits(
                            article.visited
                        )}
                        {" "}
                        بازدید
                    </span>

                </div>

            </div>


            {article.image && (
                <div className="article-header__image-wrapper">

                    <img
                        className="article-header__image"
                        src={article.image}
                        alt={article.title}
                    />

                </div>
            )}

        </header>
    );
}


/*
|--------------------------------------------------------------------------
| Date
|--------------------------------------------------------------------------
*/

function formatPersianDate(date) {
    if (!date) {
        return "";
    }

    try {
        return new Intl.DateTimeFormat(
            "fa-IR",
            {
                year: "numeric",
                month: "long",
                day: "numeric",
            }
        ).format(
            new Date(date)
        );

    } catch {
        return date;
    }
}


/*
|--------------------------------------------------------------------------
| Visits
|--------------------------------------------------------------------------
*/

function formatVisits(value) {
    const number = Number(value || 0);

    if (number >= 1000000) {
        return `${(number / 1000000).toFixed(1)}M`;
    }

    if (number >= 1000) {
        return `${(number / 1000).toFixed(1)}K`;
    }

    return number.toLocaleString("fa-IR");
}